<template>
    <span v-html="highlightText(text, highlightedText)">
    </span>
</template>

<script>
export default {
    name: 'highlightText',
    props: {
        text: {
            type: String,
            required: true
        },
        highlightedText: {
            type: String,
            default: ''
        }
    },

    methods: {

        /**
         * Highlights matching text in the caption based on search text
         * @param {string} caption - The caption text to highlight
         * @param {string} searchText - The search text to highlight
         * @returns {string} HTML string with highlighted matches
         */
         highlightText(caption, searchText) {
            if (!searchText || !caption || !searchText.trim()) {
                return this.escapeHtml(caption || '');
            }

            const normalizeString = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const searchTrimmed = searchText.trim();
            const searchLower = searchTrimmed.toLowerCase();
            const normalizedSearch = normalizeString(searchLower);
            
            // Simple approach: find all substrings that match (case and accent insensitive)
            const matches = [];
            const captionLower = caption.toLowerCase();
            
            // Try each possible starting position
            for (let i = 0; i <= caption.length - searchTrimmed.length; i++) {
                const substr = caption.substring(i, i + searchTrimmed.length);
                const normalizedSubstr = normalizeString(substr.toLowerCase());
                
                if (normalizedSubstr === normalizedSearch) {
                    matches.push({
                        start: i,
                        end: i + searchTrimmed.length
                    });
                    // Skip ahead to avoid overlapping matches
                    i += searchTrimmed.length - 1;
                }
            }

            // If no matches found, return escaped caption
            if (matches.length === 0) {
                return this.escapeHtml(caption);
            }

            // Build highlighted HTML string
            let result = '';
            let lastIndex = 0;

            matches.forEach(match => {
                // Add text before match
                if (match.start > lastIndex) {
                    result += this.escapeHtml(caption.substring(lastIndex, match.start));
                }
                
                // Add highlighted match with inline styles to ensure it works
                const matchText = caption.substring(match.start, match.end);
                result += `<span style="background-color: #2B536A33; color: inherit; font-weight: inherit; padding: 0px; border-radius: 2px;">${this.escapeHtml(matchText)}</span>`;
                
                lastIndex = match.end;
            });

            // Add remaining text after last match
            if (lastIndex < caption.length) {
                result += this.escapeHtml(caption.substring(lastIndex));
            }

            return result || this.escapeHtml(caption);
        },

        /**
         * Escapes HTML special characters to prevent XSS
         * @param {string} text - Text to escape
         * @returns {string} Escaped HTML string
         */
        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        }
    }
}
</script>

<style scoped>
</style>